import type {ReportsPage_viewer$data as ReportsPage_viewer} from './__generated__/ReportsPage_viewer.graphql';

export type ReportItem = NonNullable<
	NonNullable<NonNullable<NonNullable<NonNullable<ReportsPage_viewer['company']>['allSavedReports']>['edges']>[0]>['node']
>;

export type ReportRow = {
	isShared: boolean;
	/** The type name as the list shows it. The stored `type` keeps its own spelling alongside this. */
	typeLabel: string;
	isSharedWithViewer: boolean;
	isReportOwner: boolean;
	access: string;
	lastViewed: Date | null;
	updatedAt: Date | null;
} & Omit<ReportItem, 'updatedAt' | 'lastViewed'>;

export type BulkDeleteSavedReportMutationResponse = {
	bulkDeleteSavedReport: {deletedReportIds: number[]};
};

export enum ReportState {
	SAVED = 'SAVED',
	TEMPORARY = 'TEMPORARY',
}
